package co.uk.paxes.pinpoint.model

import kotlinx.serialization.Serializable

@Serializable
data class Move(
    val playerId: String,
    val pin: Pin,
    val position: Position,
    val timestamp: Long = 0L
) {
    fun isValid(): Boolean {
        return playerId.isNotBlank() && position.isValid()
    }
}
